import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@material-ui/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import { StyledEngineProvider } from '@material-ui/core/styles';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { permission } from './platform/permission';
import { profiles } from './platform/profiles';
import { PhinxAppProvider } from './lib/phinxapp/profiles/PhinxApp';
import { AppTheme } from './theme';

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={AppTheme}>
        <Router>
          <PhinxAppProvider profiles={profiles} rules={permission} profile="initial">
            <App />
          </PhinxAppProvider>
        </Router>
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
